module.exports = __webpack_public_path__ + "static/media/ThomasOberleitner.1f253e17.jpg";